module.exports = __webpack_public_path__ + "img/icon-gallery.3daa4ef5.svg";